import * as XLSX from 'xlsx';

// Downloads rows as an .xlsx file.
// rows: array of objects. columns (optional): [{ key, label, format? }] to pick/rename/format fields;
// when omitted, flat object keys are used (nested objects/arrays are JSON-stringified).
export default function exportToExcel(rows, fileName = 'export', columns, sheetName = 'Sheet1') {
  const list = Array.isArray(rows) ? rows : [];
  const flatten = (v) => {
    if (v === null || v === undefined) return '';
    if (v instanceof Date) return v.toISOString().slice(0, 10);
    if (typeof v === 'object') return JSON.stringify(v);
    return v;
  };
  const data = columns?.length
    ? list.map((row) =>
        Object.fromEntries(
          columns.map(({ key, label, format }) => {
            const raw = String(key).split('.').reduce((o, k) => (o == null ? o : o[k]), row);
            return [label || key, format ? format(raw, row) : flatten(raw)];
          })
        )
      )
    : list.map((row) => Object.fromEntries(Object.entries(row || {}).map(([k, v]) => [k, flatten(v)])));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, String(sheetName).replace(/[\\/?*[\]:]/g, '-').slice(0, 31));
  XLSX.writeFile(wb, `${String(fileName).replace(/\s+/g, '_')}.xlsx`);
}
